export function groupModelFn(item: any) {
  return (item.bodyType === undefined || item.bodyType === "") ? "CAR" : item.bodyType;
}
